import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RouteGuard } from './route-guard.service';
import { PaymentGuard } from './payment-guard.service';
import { OtherPathGuard } from './other-path-guard.service';
import { TicketComponent } from './Ticket/Components/ticket.component';
import { PaymentComponent } from './Payment/Components/payment.component';
import { NotFoundComponent } from './not-found.component';
import { ErrorComponent } from './error.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/ticket-search',
    pathMatch: 'full'
  },
  {
    path: 'ticket-search',
    component: TicketComponent,
    canActivate: [RouteGuard]
  },
  {
    path: 'payment',
    component: PaymentComponent,
    canActivate: [PaymentGuard]
  },
  {
    path: '404',
    component: NotFoundComponent,
    canActivate: [OtherPathGuard]
  },
  {
    path: '500',
    component: ErrorComponent,
    canActivate: [OtherPathGuard]
  },
  {
    path: '**',
    component: NotFoundComponent
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
    providers: [
    RouteGuard,
    PaymentGuard,
    OtherPathGuard
  ],
})
export class AppRoutingModule { }

export const routedComponents = [TicketComponent, PaymentComponent, NotFoundComponent, ErrorComponent];



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/app-routing.module.ts